import getUniqueKey from "@/helpers/getUniqueKey";

export default function Leerling(options, type) {
  // convert subgroepen to samengestelde_groepen
  if (options.subgroepen) {
    options.samengestelde_groepen = { samengestelde_groep: [] };
    if (options.subgroepen) {
      options.subgroepen.groep.forEach((group) => {
        options.samengestelde_groepen.samengestelde_groep.push(group);
      });
    }
  }

  if (type === "json") {
    this.key = { key: options.key || getUniqueKey() };
  } else {
    this.key = { key: options.key.key || options.key.eckid };
  }
  this.achternaam = options.achternaam;
  this.voorvoegsel = options.voorvoegsel;
  this["voorletters-1"] = options["voorletters-1"];
  this.roepnaam = options.roepnaam;
  this.jaargroep = {
    naam: options.jaargroep,
    key: options.jaargroep,
  };
  this.groep = options.groep;
  this.samengestelde_groepen = options.samengestelde_groepen;
}
